export default __webpack_public_path__ + "static/media/sanmar16.f1c6317d.jpg";